import React from "react";

function BackArrowIcon()
{
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
            <path stroke="#638CA3" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="m10 8-4 4m0 0 4 4m-4-4h12"/>
        </svg>
    );
}

export default BackArrowIcon;